import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=7783c2f1"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7783c2f1')) {
      api.createRecord('7783c2f1', component.options)
    } else {
      api.reload('7783c2f1', component.options)
    }
    module.hot.accept("./TermsAndConditions.vue?vue&type=template&id=7783c2f1", function () {
      api.rerender('7783c2f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/TermsAndConditions.vue"
export default component.exports